import {Injectable} from '@angular/core';
import { HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppService } from 'src/app/core/services/app.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor 
{
  constructor(private appService: AppService) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> 
  {
    return next.handle(req).pipe(catchError((err) => this.handleError(err)));
  }

  private handleError(err: HttpErrorResponse): Observable<any> 
  {
    if (err.status === 401) 
    {
      window.location.href = environment.procertFront + "/login";
      this.appService.tokenOAuth = "";
      this.appService.saveInLocal(environment.userStorage, null);
      this.appService.checkLogged();
    }
    return throwError(() => err);
  }

}
